import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import { useCallback, useEffect, useState } from 'react';

type SnackbarProps = Readonly<{
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose: () => unknown;
}>;

export default function Snackbar({
  message,
  severity,
  duration,
  onClose,
}: SnackbarProps) {
  const [open, setOpen] = useState(true);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (!duration) {
      return;
    }

    const timer = setTimeout(handleClose, duration);
    return () => clearTimeout(timer);
  }, [duration, handleClose]);

  return (
    <Slide direction="up" in={open} onExited={onClose} unmountOnExit>
      <Alert
        severity={severity}
        variant="filled"
        elevation={8}
        onClose={handleClose}
        sx={{ borderRadius: '4px' }}
      >
        {message}
      </Alert>
    </Slide>
  );
}
